import { BATCH_ITEM_STATUS } from "../hooks/useBatchImageEdit";

export const getTileDisplayState = (itemState, visibleVersion) => {
  const versionEntry =
    itemState.versions[visibleVersion] || itemState.versions[1] || null;
  const status = versionEntry?.status || BATCH_ITEM_STATUS.SUCCESS;

  if (versionEntry?.url) {
    return { imageUrl: versionEntry.url, status };
  }

  if (visibleVersion > 1) {
    const previousEntry = itemState.versions[visibleVersion - 1];
    if (previousEntry?.url) {
      return { imageUrl: previousEntry.url, status };
    }
  }

  return {
    imageUrl: itemState.versions[1]?.url || null,
    status,
  };
};
